const zhCN = { 
  tabRefreshInterval: '数据看板刷新时间',

  refreshIntervalTitle: '数据看板刷新时间',
  dataRefreshInterval: '访客/人员进出数据刷新时间',
  lineRefreshInterval: '访客/人员进出折线图刷新时间',
  otherRefreshInterval: '其他统计数据刷新时间',
  refreshIntervalTxt: '刷新时间',
  refreshIntervalBlank: '请输入刷新时间！',

  intervalUnit: '秒',

  submitRefreshTimeBtn: '提交设置',

  requestBasicFail: '获取基本设置失败！',
  setBasicSuccess: '修改基本设置成功！',
  setBasicFail: '修改基本设置失败！'  
  
}
const enUS = {
  tabRefreshInterval: 'Dashboard Refresh Interval',

  refreshIntervalTitle: 'Dashboard Refresh Interval Settings',
  dataRefreshInterval: 'Refresh interval for number of entry and out',
  lineRefreshInterval: 'Refresh interval for line chart of entry and out',
  otherRefreshInterval: 'Refresh interval for other statistics',
  refreshIntervalTxt: 'Refresh interval',
  refreshIntervalBlank: 'Refresh interval can\'t be blank!',

  intervalUnit: 's',
  submitRefreshTimeBtn: 'Submit Settings',

  requestBasicFail: 'Request Basic Settings failed!',
  setBasicSuccess: 'Save Basic Settings successfully!',
  setBasicFail: 'Save Basic Settings failed!'
}

export default { zhCN, enUS }